<template>
  <div v-if="costing.id">
    <div class="costing-top">
      <div class="costing-variables opportunity container">
        <div class="row">
          <div v-if="!costingDisabled" class="col-auto">
            <a @click="editRates = !editRates" class="btn inline-block">
              <i v-if="editRates" class="fa fa-lock-open"/>
              <i v-else class="fa fa-lock"/>
            </a>
          </div>
          <div class="col-11">
            <div class="row">
            <div class="col-12 col-sm-6 col-xl-3">
              <div class="form-group row">
                <label class="control-label col-5">Effort Rate</label>
                <div class="col-7">
                  <div class="input-group">
                    <input
                      type="text"
                      class="form-control"
                      v-model="editCosting.effort_rate"
                      @blur="saveCosting"
                      :disabled="costingDisabled || !editRates"
                    />
                    <span class="input-group-text">
                      /hr
                    </span>
                  </div>
                </div>
              </div>
              <!-- /.form-group -->
            </div>
            <div class="col-12 col-sm-6 col-xl-3">
              <div class="form-group row">
                <label class="control-label col-5">Margin</label>
                <div class="col-7">
                  <div class="input-group">
                    <input
                      type="text"
                      class="form-control"
                      v-model="editCosting.bugs"
                      @blur="saveCosting"
                      :disabled="costingDisabled || !editRates"
                    />
                    <span class="input-group-text">
                      %
                    </span>
                  </div>
                </div>
              </div>
              <!-- /.form-group -->
            </div>
            <div class="col-12 col-sm-6 col-xl-3">
              <div class="form-group row">
                <label class="control-label col-5">Project Management</label>
                <div class="col-7">
                  <div class="input-group">
                    <input
                      type="text"
                      class="form-control"
                      v-model="editCosting.project_management"
                      @blur="saveCosting"
                      :disabled="costingDisabled || !editRates"
                    />
                    <span class="input-group-text">
                      %
                    </span>
                  </div>
                </div>
              </div>
              <!-- /.form-group -->
            </div>
            <div class="col-12 col-sm-6 col-xl-3">
              <div class="form-group row">
                <label class="control-label col-5">Hourly Rate</label>
                <div class="col-7">
                  <div class="input-group">
                    <span class="input-group-text">
                      $
                    </span>
                    <input
                      type="text"
                      class="form-control"
                      v-model="editCosting.hour_rate"
                      @blur="saveCosting"
                      :disabled="costingDisabled || !editRates"
                    />
                    <span class="input-group-text">
                      /hr
                    </span>
                  </div>
                </div>
              </div>
              <!-- /.form-group -->
            </div>
            </div>
          </div>
        </div>
        <!-- /.row -->
      </div>
      <!-- /.costing-variables -->
    </div>
    <!-- /.costing-top -->

    <div class="scroll-costing">
      <div class="stage-costing">
        <div class="row row-area-name">
          <div class="col-5 costing-cell">
            <div class="row">
              <div class="col-sm-6 col-lg-3">
                <p class="costing">
                  $ {{ getBaseLine.total_ex | currency }}
                  <small>Ex GST</small>
                </p>
              </div>
              <div v-if="$can('read sales')" class="col-sm-6 col-lg-3">
                <p :class="{ costing, 'text-danger': budgetRemaining < 0 }">${{ budgetRemaining | currency0 }}</p>
                <p>Delivery Budget Remaining</p>
              </div>
              <div v-if="$can('read sales')" class="col-sm-4 col-lg-2">
                <p class="costing">${{ opportunity.client_budget | currency0 }}</p>
                <p>Total Budget</p>
              </div>
              <div v-if="$can('read sales')" class="col-sm-4 col-lg-2">
                <p class="costing">${{ opportunity.license_fee | currency0 }}</p>
                <p>Estimated License Fee</p>
              </div>
              <div v-if="$can('read sales')" class="col-sm-4 col-lg-2">
                <p class="costing">${{ opportunity.margin | currency0 }}</p>
                <p>Estimated Margin</p>
              </div>
            </div>
          </div>
          <div class="col flex-cell">
            <span class="area-title text-start"></span>
          </div>
          <div class="col flex-cell">
          </div>
          <div class="col flex-cell">
            <!-- <span class="area-title"><strong>Total Hours</strong></span> -->
          </div>
          <div class="col flex-cell">
            <!-- <span class="area-title"><strong>Adjustment</strong></span> -->
          </div>
          <div class="col flex-cell">
            <!-- <span class="area-title"><strong>Cost</strong></span> -->
          </div>
          <div class="col options"></div>
        </div>

        <epic-list></epic-list>
      </div>
    </div>

    <div class="row" v-if="!epics.length">
      <div class="col-md-4 offset-md-4">
        <br />
        <br />
        <br />
        <div class="form-group">
          <label class="control-label col-xs-5">Get started by selecting a template</label>

          <multiselect
            :show-labels="false"
            v-model="template"
            :options="templates"
            label="name"
            track-by="id"
            placeholder=""
            @select="templateSelected"
          ></multiselect>
        </div>
      </div>
    </div>

    <!-- <iframe style="width:100%;height:1200px" src="https://app.pandadoc.com/a/#/document/v1/editor/5vnUBL4mmD33UTiek5YwsE/content"></iframe> -->
  </div>
</template>

<script>
import { notify } from 'utils'
import { cloneDeep } from 'lodash'
import draggable from 'vuedraggable'
import Multiselect from 'vue-multiselect'
import { mapState, mapActions, mapGetters } from 'vuex'

import EpicList from 'components/opportunities/epics/EpicList.vue'

export default {
  components: {
    draggable,
    EpicList,
    Multiselect,
  },

  data: function() {
    return {
      editCosting: {},
      editRates: false,
      template: null,
    }
  },

  computed: {
    ...mapState('project', ['project']),
    ...mapState('epics', ['epics']),
    ...mapState('opportunity', {
      opportunity: 'single',
    }),
    ...mapState('costing', ['costing']),
    ...mapState('templates', ['templates']),
    ...mapGetters('costing', ['getBaseLine']),
    ...mapGetters('opportunity', ['isSigned']),

    budgetRemaining() {
      return (this.opportunity.budget_remaining - this.getBaseLine.total_ex).toFixed()
    },

    costingDisabled () {
      return this.isSigned || this.opportunity.approved_at != null
    }
  },
  mounted() {
    this.onUpdateCosting = () => {
      this.reCalculateCosting(this.costing.user_story_document_id)
    }

    this.$bus.$on('updateCosting', this.onUpdateCosting)

    this.editCosting = cloneDeep(this.costing)
  },

  beforeDestroy() {
    this.$bus.$off('updateCosting', this.onUpdateCosting)
  },
  methods: {
    ...mapActions('userStoryDocument', ['getUserStoryDocument']),
    ...mapActions('costing', ['getCosting', 'updateCosting', 'reCalculateCosting', 'useTemplate']),
    ...mapActions('opportunity', {
      updateOpportunity: 'updateSingle',
      getOpportunity: 'getSingle',
    }),

    async saveCosting() {
      await this.updateCosting({
        userStoryDocumentId: this.costing.user_story_document_id,
        costingId: this.costing.id,
        payload: this.editCosting,
      }).then(() => {
        this.reCalculateCosting(this.costing.user_story_document_id)
      })
    },
    saveOverview(data) {
      return this.updateOpportunity({ id: this.opportunity.id, payload: { overview: data } })
    },
    saveProcess(data) {
      return this.updateOpportunity({ id: this.opportunity.id, payload: { process: data } })
    },
    templateSelected(template) {
      this.$swal({
        title: 'Confirm Template Selection',
        html: 'This will replace all line items in this opportunity with the select template items. Continue?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes',
      }).then(
        () => {
          this.editCosting.template_id = template.id

          return this.useTemplate({ opportunityId: this.opportunity.id, payload: this.editCosting }).then(() => {
            //Load the epics / costing
            this.getOpportunity(this.opportunity.id)
            this.getUserStoryDocument(this.opportunity.user_story_document_id)
            this.getCosting(this.opportunity.user_story_document_id)
          })
        },
        function() {
          this.template = null
        }
      )
    },
  },
}
</script>
